import type { VoidFunctionComponent } from 'react';
import { Category } from '../../../../../shared/issuesV2';
import VulnerabilityHeader from '../Vulnerability/Header';
import LicensingHeader from '../Licensing/Header';
import QualityHeader from '../Quality/Header';

type Props = {
  category: Category;
};

/**
 * Displays the content of the header base on the category.
 */
const IssueDetailsV2Header: VoidFunctionComponent<Props> = ({ category }) => {
  switch (category) {
    case Category.Vulnerability:
      return <VulnerabilityHeader />;
    case Category.Licensing:
      return <LicensingHeader />;
    case Category.Quality:
      return <QualityHeader />;
    default:
      return null;
  }
};

export default IssueDetailsV2Header;
